import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ContextProvider, initialState } from "./context";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";

const _kc = new Keycloak({
  // @ts-ignore
  realm: process.env.REACT_APP_KEYCLOACK_REALM,
  url: process.env.REACT_APP_KEYCLOACK_URL,
  // @ts-ignore
  clientId: process.env.REACT_APP_KEYCLOACK_CLIENT_ID,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const renderApp = () =>
  root.render(
    <ReactKeycloakProvider authClient={_kc}>
      <React.StrictMode>
        <ContextProvider initialProps={initialState}>
          <App />
        </ContextProvider>
      </React.StrictMode>
    </ReactKeycloakProvider>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// renderApp();
reportWebVitals();
renderApp();
